import { createSlice } from "@reduxjs/toolkit";
import { archiveProperty, getPropertyList } from "./_propertyAction";


interface ManageUserState {
  propertyList: any[];
  loading: boolean;
  error: string | null;
  totalCount: number
}

const initialState: ManageUserState = {
  propertyList: [],
  loading: false,
  error: null,
  totalCount: 0
};


export const propertyReducer = createSlice({
  name: "property",
  initialState: initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Invite User List
      .addCase(getPropertyList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPropertyList.fulfilled, (state, action) => {        
        state.loading = false;
        state.propertyList = action.payload?.data;
        state.totalCount = action.payload?.count;
      })
      .addCase(getPropertyList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Archive Property
      .addCase(archiveProperty.fulfilled, (state, action) => {
        state.propertyList = state.propertyList.filter((property) => property.uuid !== action.payload?.data?.uuid);
      })
      .addCase(archiveProperty.rejected, (state, action) => {
        state.error = action.payload as string;
      })
  },
});


export const { clearError } = propertyReducer.actions;
export default propertyReducer;